export { default as PageWrap } from './PageWrap';
export { default as PageWithTabs } from './PageWithTabs';



// WEBPACK FOOTER //
// ./src/layouts/index.ts